import { render } from "./UsageTermsZhCn.vue?vue&type=template&id=12d5ba00&scoped=true"
import script from "./UsageTermsZhCn.vue?vue&type=script&lang=js"
export * from "./UsageTermsZhCn.vue?vue&type=script&lang=js"

import "./UsageTermsZhCn.vue?vue&type=style&index=0&id=12d5ba00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d5ba00"]])

export default __exports__